import { Flex } from '@chakra-ui/react';
import { Alert, AlertDescription, Button } from '@/components/v4';

const SyncRetirementBanner = ({ onUpgrade }) => {
    return (
        <Alert
            status="warning"
            variant="left-accent"
            justifyContent="space-between"
            mb={4}>
            <AlertDescription flex={1}>
                <Flex as="span" wrap="wrap" gap={1} alignItems="center">
                    <span>
                        <strong>
                            Legacy Microsoft authentication is no longer
                            supported as of October 3rd 2026.
                        </strong>{' '}
                        Upgrade to prevent service delays and avoid disruption
                        in the future.
                    </span>
                </Flex>
            </AlertDescription>
            <Button
                colorScheme="messenger"
                size="sm"
                ml={4}
                flexShrink={0}
                onClick={onUpgrade}>
                Upgrade now
            </Button>
        </Alert>
    );
};

export default SyncRetirementBanner;
